import { Produto } from '../types/produtos';

export function searchProdutosRelacionados(produtos: Produto[], searchTerm: string): Produto[] {
  if (!searchTerm.trim() || searchTerm.trim().length < 2) return [];

  // Filtra palavras muito curtas (artigos, preposições) para evitar ruído
  const terms = searchTerm.toLowerCase().trim().split(/\s+/).filter(t => t.length >= 3);
  if (terms.length === 0) return [];

  // Busca apenas no nome — descricao/marca causam falsos positivos irrelevantes
  return produtos.filter(p => {
    const nome = p.nome.toLowerCase();
    return terms.some(term => nome.includes(term));
  });
}
